import type { SVGProps } from 'react';
import { forwardRef } from 'react';

const LogicalAndIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  function LogicalAndIcon(props, ref) {
    return (
      <svg
        ref={ref}
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <mask
          id="mask0_231_9219"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="17"
          height="16"
        >
          <rect x="0.5" width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_231_9219)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.92847 12.75C6.88453 12.75 7.77096 12.4518 8.49984 11.9434C9.22873 12.4518 10.1152 12.75 11.0712 12.75C13.5565 12.75 15.5712 10.7353 15.5712 8.25C15.5712 5.76472 13.5565 3.75 11.0712 3.75C10.1152 3.75 9.22873 4.04815 8.49984 4.55655C7.77096 4.04815 6.88453 3.75 5.92847 3.75C3.44319 3.75 1.42847 5.76472 1.42847 8.25C1.42847 10.7353 3.44319 12.75 5.92847 12.75ZM7.31883 5.41605C6.52803 6.18973 6.05414 7.17596 6.05414 8.2501C6.05414 9.32413 6.52794 10.3103 7.31859 11.0839C6.89919 11.29 6.42737 11.4058 5.92851 11.4058C4.18559 11.4058 2.77267 9.99285 2.77267 8.24993C2.77267 6.507 4.18559 5.09408 5.92851 5.09408C6.42747 5.09408 6.89937 5.20987 7.31883 5.41605ZM9.65823 11.0726C10.4419 10.3006 10.9111 9.31888 10.9111 8.2501C10.9111 7.18122 10.4418 6.19937 9.65799 5.42742C10.0831 5.21413 10.5631 5.09408 11.0712 5.09408C12.8141 5.09408 14.227 6.507 14.227 8.24993C14.227 9.99285 12.8141 11.4058 11.0712 11.4058C10.5632 11.4058 10.0833 11.2858 9.65823 11.0726Z"
            fill="#1F1F22"
          />
        </g>
      </svg>
    );
  },
);

export default LogicalAndIcon;
